import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Sidebar from "../user/sidebar";
import {
  Container,
} from "@mui/material";

function TransactionRequest({ transactionData, disputeData }) {
  const navigate = useNavigate();
  const sentReq = useSelector((state) => state.user.buyer.pending_seller_transactions);
  const receivedReq = useSelector((state) => state.user.buyer.pending_buyer_transactions);
  const contract = useSelector((state) => state.user.buyer);
  const [showSent, setShowSent] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  console.log(contract)

  const toggleTransactions = () => {
    setShowSent(!showSent);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  return (
    <Container maxWidth="xl" style={{ display: "flex" }}>
    <Sidebar />
    <div className="p-4 w-full rounded-lg h-[calc(100vh_-_150px)] shadow-md mx-auto">
      <h2 className="text-2xl font-semibold mb-4">Transaction Details</h2>

      <input
        type="text"
        className="text-black rounded-lg px-2 py-1 mb-4"
        placeholder="Search transactions"
        value={searchTerm}
        onChange={handleSearchChange}
      />

      <button
        className="bg-blue-500 text-black font-semibold px-4 py-2 rounded-lg mb-4 ml-4"
        onClick={toggleTransactions}
      >
        {showSent ? "Show Received Transactions" : "Show Sent Transactions"}
      </button>

      <table className="w-full table-auto bg-blue-500">
        <thead>
          <tr>
            <th className="px-4 py-2">Transaction ID</th>
            <th className="px-4 py-2">Sender Name</th>
            <th className="px-4 py-2">Receiver Name</th>
            <th className="px-4 py-2">Status</th>
            <th className="px-4 py-2">Amount</th>
          </tr>
        </thead>
        <tbody>
          {showSent
            ? sentReq
                .filter((transaction) => transaction.opposite_user.email.toLowerCase().includes(searchTerm))
                .map((sent_transaction) => (
                  <tr
                    key={sent_transaction.id}
                    onClick={() => navigate(`/pending-sent-transaction/${sent_transaction.id}`)}
                    className="cursor-pointer hover:bg-white hover:text-black"
                  >
                    <td className="px-4 py-2">{sent_transaction.id}</td>
                    <td className="px-4 py-2">{sent_transaction.opposite_user.email}</td>
                    <td className="px-4 py-2">{sent_transaction.user.email}</td>
                    <td className="px-4 py-2">{sent_transaction.buyer_confirmation}</td>
                    <td className="px-4 py-2">{sent_transaction.amount}</td>
                  </tr>
                ))
            : receivedReq
                .filter((transaction) => transaction.opposite_user.email.toLowerCase().includes(searchTerm))
                .map((received_transaction) => (
                  <tr
                    key={received_transaction.id}
                    onClick={() => navigate(`/pending-received-transaction/${received_transaction.id}`)}
                    className="cursor-pointer hover:bg-white hover:text-black"
                  >
                    <td className="px-4 py-2">{received_transaction.id}</td>
                    <td className="px-4 py-2">{received_transaction.opposite_user.email}</td>
                    <td className="px-4 py-2">{received_transaction.user.email}</td>
                    <td className="px-4 py-2">{received_transaction.buyer_confirmation}</td>
                    <td className="px-4 py-2">{received_transaction.amount}</td>
                  </tr>
                ))}
        </tbody>
      </table>
    </div>
    </Container>
  );
}

export default TransactionRequest;
